import { observer } from "mobx-react-lite";
import ReviewExportCard from "./review/ReviewExportCard";
import ReviewStatsGrid from "./review/ReviewStatsGrid";
import ReviewDelegationsCard from "./review/ReviewDelegationsCard";
import ReviewDisclosureTable from "./review/ReviewDisclosureTable";
import ESGReportPreviewModal from "./print/ESGReportPreviewModal";
import {
  useESGReportWorkflowStore,
  useESGReportBuilderStore,
  useESGDisclosureSelectionStore,
} from "@/features/esg/hooks/useESGReportStore";
import { useTran } from "@/hooks";

const ReviewStep = observer(() => {
  const { t } = useTran();
  const {
    showPreviewModal,
    setShowPreviewModal,
    reviewExportFramework,
    setReviewExportFramework,
  } = useESGReportWorkflowStore();
  const { framework } = useESGReportBuilderStore();
  const { availableExportFrameworks } = useESGDisclosureSelectionStore();

  return (
    <div className="flex-1 flex flex-col gap-y-6 min-h-0 overflow-y-auto">
      {/* Framework Selector - only for UNIVERSAL */}
      {framework === "UNIVERSAL" && availableExportFrameworks.length > 1 && (
        <div className="rounded-radius border border-border bg-card p-4 shadow-sm">
          <div className="flex items-center justify-between gap-4">
            <div>
              <p className="text-sm font-semibold text-foreground">
                {t("Export Framework Filter")}
              </p>
              <p className="text-xs text-muted-foreground">
                {t(
                  "Select a framework to filter review data and exports. Choose 'All Frameworks' to include all disclosures.",
                )}
              </p>
            </div>
            <div className="flex flex-wrap gap-1">
              {availableExportFrameworks.map((fw) => (
                <button
                  key={fw}
                  type="button"
                  className={`text-xs px-3 py-1.5 rounded-full border transition-colors font-medium ${
                    reviewExportFramework === fw
                      ? "bg-primary text-primary-foreground border-primary"
                      : "bg-muted text-muted-foreground border-border hover:bg-background"
                  }`}
                  onClick={() => setReviewExportFramework(fw)}
                >
                  {fw === "All" ? t("All Frameworks") : fw}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
      {/* Top row: Progress card + Stats */}
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-5">
        <div className="lg:col-span-3">
          <ReviewExportCard />
        </div>
        <div className="lg:col-span-2">
          <ReviewStatsGrid />
        </div>
      </div>

      {/* Bottom row: Delegation inbox + Report content */}
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <ReviewDelegationsCard />
        </div>
        <div className="lg:col-span-3">
          <ReviewDisclosureTable />
        </div>
      </div>

      <ESGReportPreviewModal
        open={showPreviewModal}
        onOpenChange={setShowPreviewModal}
      />
    </div>
  );
});

export default ReviewStep;
